export const DAY_KIND = {
    평일: 0,
    토요일공휴일: 1,
    일요일: 2,
}